import { usePublicConfig } from '../firebase/hooks';
import { useNonNullableContext } from '../hooks/useNonNullableContext';
import { WizardContext } from '../contexts/WizardContext/WizardContext';
import {
  fallbackLanguageSettings,
  RmaSupportedLanguage,
  fallbackLanguage,
} from '../../../../functions/src/shared';

export interface UseLanguageSettings {
  language: string;
  defaultLanguage: string;
  languageSettingsEnabled: boolean;
  additionalLanguages: RmaSupportedLanguage[];
}

export const useLanguage = (): UseLanguageSettings => {
  const publicConfig = usePublicConfig();
  const { language: contextLanguage } = useNonNullableContext(WizardContext);

  const { languageSettingsEnabled, additionalLanguages } =
    publicConfig?.languageSettings || fallbackLanguageSettings;

  const language = languageSettingsEnabled
    ? contextLanguage
    : publicConfig?.language || fallbackLanguage;

  return {
    language,
    languageSettingsEnabled,
    additionalLanguages,
    defaultLanguage: publicConfig?.language || fallbackLanguage,
  };
};
